import styled from 'styled-components';

import { TrophyProps } from './About.types';

export const Trophy = styled.div<TrophyProps>`
  border-radius: 50%;
  background-color: ${({ prize }) => {
    if (prize === 'gold') return '#D4AF37';
    else if (prize === 'silver') return '#D7D7D7';
    return '#A77044';
  }};

  color: black;

  display: flex;
  align-items: center;

  font-size: 1.5rem;
  margin-right: 0.75rem;
  padding: 0.75rem;
`;

export const Prize = styled.div`
  color: white;
  display: flex;
  font-family: 'Montserrat';
  font-size: 1.25rem;
  align-items: center;
`;

export const PrizeWrapper = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-between;

  ${Prize} {
    margin-bottom: 1rem;
  }

  @media only screen and (min-width: 768px) {
    flex-flow: row;

    ${Prize} {
      margin-bottom: 0;
    }
  }
`;

export const SaberLogo = styled.img`
  max-width: 100%;
`;
